import { Component } from '@angular/core';
import { MenuService } from '../../services/menu.service';
import { AuthService } from '../../../auth/services/auth.service';
import { Router } from '@angular/router';
import { UserService } from '../../../user/services/user.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss'
})
export class TopbarComponent {
  userId: string = '';
  userName: string = '';
  roleId: string = '';
  isDropdownOpen = false;
  unreadCount: number = 0;

  constructor(private menuService: MenuService,
    private authService: AuthService,
    private router: Router,
    private userService: UserService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    /* this.userService.selectedUserId$.subscribe(user => {
      if (user) {
        this.loadUserInfo(user);
      }
    }); 
     this.userService.userRole$.subscribe(role => {
      this.roleId = role;
    }); */

    this.userId=this.userService.getselectedUserId()
  this.loadUserInfo(this.userId)

    this.roleId = this.userService.getUserRole()

    this.notificationService.getUnread().subscribe((data:any) => {
      this.unreadCount = data.length;
    });
  }

  loadUserInfo(id: string) {
    this.userService.getById(id).subscribe((res) => {
      if (res) {
        const user = res;
        if (user) {
          this.userName = user.name;
        }
      }
    });
  }

  toggleSidebar() {
/*     console.log('Abrir Menú');
 */    this.menuService.toggleSidebar();
  }

  logout(): void {
    this.authService.logout();
    this.menuService.reset(); // si usas reset para limpiar menú
    this.router.navigate(['/login']);
  }

  routeToSettings() {
    this.router.navigate(['/settings']);
  }

  routeToProfile() {
    this.router.navigate(['/user/personal-profile']);
  }

  navigateToNotifications() {
    this.router.navigate(['/notifications']);
  }
}
